import { CommonModule } from '@angular/common';
import { Component, computed, input, model, Signal } from '@angular/core';

export interface ICheckboxOption {
  label: string;
  value: any;
}

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  imports: [CommonModule],
})
export class Checkbox {
  value = model<ICheckboxOption | undefined>();
  selectedValues = input<ICheckboxOption[]>([]);
  isSelected: Signal<boolean> = computed(() =>
    this.selectedValues()?.some((v) => v.value === this.value()?.value),
  );
}
